import { createContext } from 'react';

type Theme = 'light' | 'dark';
export type Density = 'comfortable' | 'compact';

/** Cores de destaque curadas (handoff Íris). A primeira é o default. */
export const ACCENTS = [
  { hex: '#4f46e5', nome: 'Índigo' },
  { hex: '#2563eb', nome: 'Azul Bn' },
  { hex: '#0ea5e9', nome: 'Sky' },
  { hex: '#7c3aed', nome: 'Violeta' },
  { hex: '#059669', nome: 'Esmeralda' },
] as const;

/**
 * Skins do "chrome" (barra lateral + topo). Cada id tem um bloco
 * `:root[data-skin='<id>'] .app-chrome` no index.css que sobrescreve os tokens
 * do tema SÓ dentro do chrome — por isso colorir menu/header não toca nos
 * componentes. 'claro' = sem override (segue o tema). `cor` é só o preview do
 * seletor. Criar skin nova = 1 bloco CSS + 1 entrada aqui.
 */
export const SKINS = [
  { id: 'claro', nome: 'Claro', cor: '#e8eaed' },
  { id: 'cinza', nome: 'Cinza', cor: '#2a2d34' },
  { id: 'azul', nome: 'Azul', cor: '#16335c' },
  { id: 'preto', nome: 'Preto', cor: '#111113' },
] as const;

export type SkinId = (typeof SKINS)[number]['id'];

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
  density: Density;
  setDensity: (d: Density) => void;
  accent: string;
  setAccent: (hex: string) => void;
  /** Cor do menu lateral + topo (chrome). 'claro' segue o tema. */
  skin: SkinId;
  setSkin: (id: SkinId) => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
